import {
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  styled,
  Typography,
} from "@mui/material";
import React from "react";

const DescGrid = styled(Grid)(({ theme }) => ({
  padding: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "10%",
}));

const InputWidth = styled(FormControl)(({ theme }) => ({
  width: "80%",
}));

type Props = {
  title: string;
  value: string;
  selection: { value: string; text: string }[];
  handleEdit: (e: any) => void;
  helperText?: string;
  helperTextColor?: string;
};

export default function InputSelect({
  title,
  value,
  selection,
  handleEdit,
  helperText,
  helperTextColor = "error",
}: Props) {
  return (
    <Grid container justifyContent="center">
      <DescGrid container justifyContent="center">
        <TitleGrid item xs={12}>
          <Typography component="span" variant="h6" color="black">
            {title}
          </Typography>
        </TitleGrid>
        <Grid container justifyContent="center" item xs={12}>
          <InputWidth>
            <Select
              labelId="input-select-label"
              id="input-select"
              value={value}
              onChange={handleEdit}
            >
              {selection.map((value, key) => (
                <MenuItem value={value.value} key={key}>
                  {value.text}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>
              <Typography component="span" color={helperTextColor} sx={{ fontSize: "0.75rem" }}>
                {helperText}
              </Typography>
            </FormHelperText>
          </InputWidth>
        </Grid>
      </DescGrid>
    </Grid>
  );
}
